import type { RootFiDefaultSyncConfigV4Response } from '@commenda/types/src/root-fi/types';
import { SWRFetcher } from '@commenda/utils';
import { RootfiCompanyUseCase } from '@prisma/client';
import useSWR from 'swr';

export function useRootFiDefaultSyncConfigV4(useCases: RootfiCompanyUseCase[]) {
  const { data, error, mutate, isLoading } =
    useSWR<RootFiDefaultSyncConfigV4Response>(
      useCases.length > 0
        ? `rootfi/sync-config/default?${useCases
            .map((useCase) => `useCases=${encodeURIComponent(useCase)}`)
            .join('&')}`
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    defaultSyncConfig: data?.defaultSyncConfig,
    error,
    mutate,
    isLoading,
  };
}
